import React from 'react';

const ProductSkeleton: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50 animate-pulse">
      {/* Breadcrumb skeleton */}
      <div className="bg-white border-b">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center gap-2">
            <div className="w-12 h-3 bg-gray-200 rounded" />
            <div className="w-2 h-2 bg-gray-300 rounded-full" />
            <div className="w-16 h-3 bg-gray-200 rounded" />
            <div className="w-2 h-2 bg-gray-300 rounded-full" />
            <div className="w-24 h-3 bg-gray-200 rounded" />
          </div>
        </div>
      </div>

      <div className="w-full px-3 sm:px-4 py-3 sm:py-4 md:py-6 md:max-w-7xl md:mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-4 md:gap-6 lg:gap-8">
          {/* Image skeleton */}
          <div className="flex gap-4">
            <div className="hidden md:flex flex-col gap-2">
              {[1, 2, 3, 4].map((i) => (
                <div key={i} className="w-16 h-16 lg:w-20 lg:h-20 bg-gray-200 rounded-lg" />
              ))}
            </div>
            <div className="flex-1 aspect-[3/4] sm:aspect-square md:aspect-[4/5] bg-gray-200 rounded-xl" />
          </div>

          {/* Info skeleton */}
          <div className="space-y-4">
            <div className="space-y-2">
              <div className="w-3/4 h-6 bg-gray-200 rounded" />
              <div className="w-1/3 h-4 bg-gray-200 rounded" />
            </div>
            <div className="w-1/2 h-8 bg-gray-200 rounded" />
            <div className="w-full h-24 bg-gray-200 rounded-xl" />
            <div className="w-full h-32 bg-gray-200 rounded-xl" />
            <div className="w-full h-16 bg-gray-200 rounded-xl" />
          </div>
        </div>

        {/* Tabs skeleton */}
        <div className="mt-8">
          <div className="flex border-b border-gray-200">
            <div className="flex-1 h-10 bg-gray-200 rounded-t-lg" />
            <div className="flex-1 h-10 bg-gray-200 rounded-t-lg" />
            <div className="flex-1 h-10 bg-gray-200 rounded-t-lg" />
          </div>
          <div className="bg-white border border-t-0 border-gray-200 rounded-b-lg p-4 space-y-3">
            <div className="w-full h-3 bg-gray-200 rounded" />
            <div className="w-5/6 h-3 bg-gray-200 rounded" />
            <div className="w-4/6 h-3 bg-gray-200 rounded" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProductSkeleton;
